export function useCanonicalUrl() {
    const config = useRuntimeConfig()
    const route = useRoute()

    const canonicalUrl = computed(() => {
        return `${config.public.siteUrl}${route.path}`
    })

    return { canonicalUrl }
}

